import Label from './Label';
import VisualOnlyLabel from './VisualOnlyLabel';

export default Label;
export { VisualOnlyLabel };